import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';
import count1 from "../../../assets/images/How We Do/a. Centerlised invoicing.png";
import count2 from "../../../assets/images/How We Do/b. Guaranteed cost reduction.png";
import count3 from "../../../assets/images/How We Do/c. Hassle free coordination.png";
import count4 from "../../../assets/images/How We Do/d. One-stop purchase solutions.png";
import count5 from "../../../assets/images/How We Do/e. Transparent execution.png";
import count6 from "../../../assets/images/How We Do/f.Vendor optimisations.png";
const Process = () => {
    const features = [
        {
            image: count1,
            title: "Centerlised invoicing",
            description: "Consolidated invoicing options to cater multiple locations",
        },
        {
            image: count2,
            title: "Guaranteed cost reduction",
            description: "Optimise expenditure across categories and across locations",
        },
        {
            image: count3,
            title: "Hassle free coordination",
            description: "Single point of contact for supply engagements and executions",
        },
        {
            image: count4,
            title: "One-stop purchase solutions",
            description: "Single point of contact for all office supply requirements across locations",
        },
        {
            image: count5,
            title: "Transparent execution",
            description: "Honesty and integrity in all customer engagements",
        },
        {
            image: count6,
            title: "Vendor optimisations",
            description: "A single Vendor for multiple admin services across pan India",
        }
    ];
    return (
        <React.Fragment>
            <section className="py-5 position-relative " style={{backgroundColor: "rgb(52, 81, 159)"}}>
                <Container>
                    <Row className="gy-4">
                        <div className="text-center mb-4">
                            <h2 className="fw-bold" style={{color:"rgb(250, 250, 250)"}}>How we do</h2>
                            <p style={{color:"rgb(250, 250, 250)"}}>
                                Technology bringing all stakeholders together <br />
                                And helping brands to reach customers optimally through our tech platform
                            </p>
                        </div>

                        <Row className="text-center gy-4">
                            {features.map((feature, index) => (
                                <Col key={index} md={4} sm={6} className="d-flex align-items-stretch">
                                    <Card body className="p-4 border-0 shadow-sm text-center w-100 d-flex flex-column ">
                                        <img src={feature.image} alt={feature.title} className="mb-3 img-fluid d-block mx-auto" style={{ height: "70px", width: "70px" }} />
                                        <h5 className="fw-semibold flex-grow-0">{feature.title}</h5>
                                        <p className="text-muted flex-grow-1 d-flex align-items-center justify-content-center">{feature.description}</p>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Process;